import React from 'react';
import styled from 'styled-components';

import ShipIcon from '../ShipIcon/ShipIcon';

const Name = styled.div`
  margin-top: 6px;
  margin-bottom: 0;
  line-height: 1.4;

  @media (max-width: 667px) {
    font-size: 12px;
  }
`;

function getBackgroundGradient(rarity) {
  switch (rarity) {
    case 6:
      return 'linear-gradient(120deg, #fffb00 20%, #d49200 50%, #fda300 80%)';

    case 7:
      return 'linear-gradient(to right, #69FFAD, #7899F4 40%, #CC6D9D)';

    default:
      return 'none';
  }
}

const IconWrapper = styled.div`
  margin: auto;
  background-image: ${(props) => getBackgroundGradient(props.rarity)};
  width: 110px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const rarities = {
  common: '#afa8a8',
  1: '#afa8a8',

  rare: '#7bc3de',
  2: '#7bc3de',

  elite: '#9479d6',
  3: '#9479d6',

  'super rare': '#ffd67b',
  4: '#ffd67b',

  5: '#ff72fe',

  6: '#ffd67b',
};

const getRarityColor = (rarity) => rarities[rarity.toString().toLowerCase()];

const styles = {
  drops: {
    color: '#777',
    fontSize: 11,
  },
  container: {
    textAlign: 'center',
  },
};

function ShipCard({
  id,
  name,
  icon,
  rarity,
  eventDrops,
  existInCollection,
  onClick = () => {},
  onClickById,
  retrofitable = false,
}) {
  let handleClick = () => onClick(name);

  if (onClickById) {
    handleClick = () => onClickById(id);
  }

  return (
    <div style={styles.container}>
      <IconWrapper rarity={rarity}>
        <ShipIcon
          icon={icon}
          name={name}
          dim={!existInCollection(name)}
          retrofitable={retrofitable}
          borderColor={getRarityColor(rarity)}
          // noBorder={[6, 7].includes(rarity)}
          onClick={handleClick}
        />
      </IconWrapper>

      <Name>
        {name}
        {eventDrops && <div style={styles.drops}>{eventDrops}</div>}
      </Name>
    </div>
  );
}

export default ShipCard;
